import { render, staticRenderFns } from "./StreakInExerciseResult.vue?vue&type=template&id=0112a210&scoped=true&"
import script from "./StreakInExerciseResult.vue?vue&type=script&lang=js&"
export * from "./StreakInExerciseResult.vue?vue&type=script&lang=js&"
import style0 from "./StreakInExerciseResult.vue?vue&type=style&index=0&id=0112a210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0112a210",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
